import { Controller } from "stimulus";
// @Note: There were conflicts with using `html5-qrcode` and bundling it with webpacker.
// I then opted to use the CDN version of the library, imported in the main layout file, hence the global reference.
// will come back to this later.

export default class extends Controller {
    static targets = ["scanner", "startButton", "stopButton", "message", "value", "form"];
    static values = { qrCodeInputId: String };

    connect() {
        this.initializeScanner();
        this.toggleElement(this.stopButtonTarget, true);
    }

    initializeScanner() {
        this.scannerId = `scanner-${Math.random().toString(16).slice(2, 10)}`;
        this.scannerTarget.id = this.scannerId;
        this.scanner = new window.Html5Qrcode(this.scannerTarget.id);
    }

    startScan() {
        this.valueTarget.value = "";
        this.scanner.start(
            { facingMode: "environment" },
            { fps: 5, qrbox: { width: 250, height: 250 } },
            this.onScanSuccess.bind(this),
            this.onScanFailure.bind(this)
        ).catch(() => this.showMessage("Camera access denied. Please check your settings.", "error"));

        this.toggleScanningUI();
    }

    stopScan() {
        this.scanner.stop();
        this.toggleScanningUI();
    }

    onScanSuccess(decodedText, decodedResult) {
        this.handleSuccess(decodedText);
        this.stopScan();
    }

    onScanFailure(error) {
        if (!this.lastScanFailure || Date.now() - this.lastScanFailure > 2000) {
            this.showMessage("No QR code detected. Try again.", "warning");
            this.lastScanFailure = Date.now();
        }
    }

    showMessage(text, type) {
        const colors = { success: "green", error: "red", warning: "orange", info: "blue" };
        if (this.hasMessageTarget) {
            this.messageTarget.innerHTML = `<span style="color: ${colors[type]}">${text}</span>`;
        }
    }

    toggleScanningUI() {
        [this.startButtonTarget, this.stopButtonTarget].forEach(el => this.toggleElement(el));
    }

    toggleElement(element, force) {
        element.classList.toggle("d-none", force);
    }

    handleSuccess(value) {
        if (value) {
            if (this.hasQrCodeInputIdValue && this.qrCodeInputIdValue) {

                const modal = document.getElementById("modal")
                if (modal) {modal.innerHTML = ""}

                document.getElementById(this.qrCodeInputIdValue).value = value

            } else if (this.hasFormTarget) {
                this.valueTarget.value = value;
                this.formTarget.requestSubmit();
            } else {
                this.valueTarget.value = value;
                this.element.requestSubmit();
            }
        }
    }
}
